/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpestimatedticketsize_Modal_Minlabel5Inputs */

const en_coinvestments_gpestimatedticketsize_modal_minlabel5 = /** @type {(inputs: Coinvestments_Gpestimatedticketsize_Modal_Minlabel5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum`)
};

/**
* | output |
* | --- |
* | "Minimum" |
*
* @param {Coinvestments_Gpestimatedticketsize_Modal_Minlabel5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpestimatedticketsize_modal_minlabel5 = /** @type {((inputs?: Coinvestments_Gpestimatedticketsize_Modal_Minlabel5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpestimatedticketsize_Modal_Minlabel5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpestimatedticketsize_modal_minlabel5(inputs)
});
export { coinvestments_gpestimatedticketsize_modal_minlabel5 as "coInvestments_gpEstimatedTicketSize_modal_minLabel" }